var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConteudoPageForm',{attrs:{"apiBasePath":"/admin/site-paginas","entityName":"Página","breadcrumb":"Marketing / Páginas","listRouteName":"paginas","iaEndpoint":"/admin/site-paginas/gerar-conteudo-ia","iaPlaceholder":"Ex: Política de trocas e devoluções"}})
}
var staticRenderFns = []

export { render, staticRenderFns }